<div class="flex h-full w-full flex-col overflow-y-auto bg-white lg:overflow-hidden">
  <mat-stepper
    #stepper
    class="flex-1 shrink-0 bg-white lg:min-h-0 lg:shrink lg:overflow-hidden"
    [linear]="true"
    [orientation]="stepperOrientation()"
    labelPosition="end"
    animationDuration="0ms"
  >
    <!-- INFORMATION STEP -->
    <mat-step
      [stepControl]="$safeNavigationMigration(form?.get(steps.INFORMATION))"
      [completed]="$safeNavigationMigration(form?.get(steps.INFORMATION)?.valid)"
    >
      <ng-template matStepLabel>{{ 'SITES.CREATION_FORM.STEP.INFORMATION' | translate }}</ng-template>
      <iot-platform-ui-favorite-view-information-form
        [favoriteView]="favoriteView()"
        [masterView]="masterView()"
        [createForBusinessProfile]="createForBusinessProfile()"
        (formStateChanged)="formStateChanged()?.[steps.INFORMATION].set($event)"
        (formValue)="form.controls[steps.INFORMATION].setValue($event)"
      />
    </mat-step>

    <!-- FILTERS STEP -->
    <mat-step [stepControl]="$safeNavigationMigration(form?.get(steps.FILTERS))" [completed]="$safeNavigationMigration(form?.get(steps.FILTERS)?.valid)">
      <ng-template matStepLabel>{{ 'FAVORITE_VIEW.FORM.TABS_LABEL.FILTERS' | translate }}</ng-template>
      <iot-platform-ui-favorite-view-filters-form
        [favoriteView]="favoriteView()"
        [masterView]="masterView()"
        [filters]="currentFilters()"
        (formStateChanged)="formStateChanged()?.[steps.FILTERS].set($event)"
        (formValue)="form.controls[steps.FILTERS].setValue($event)"
      />
    </mat-step>

    <!-- GRID STEP -->
    <mat-step [stepControl]="$safeNavigationMigration(form?.get(steps.GRID))" [completed]="$safeNavigationMigration(form?.get(steps.GRID)?.valid)">
      <ng-template matStepLabel>{{ 'FAVORITE_VIEW.FORM.TABS_LABEL.GRID' | translate }}</ng-template>
      <iot-platform-ui-favorite-view-grid-form
        [favoriteView]="favoriteView()"
        [masterView]="masterView()"
        [businessProfileId]="$safeNavigationMigration(information?.getRawValue()?.businessProfileId)"
        [shared]="information?.getRawValue()?.shared ?? false"
        (formStateChanged)="formStateChanged()?.[steps.GRID].set($event)"
        (formValue)="form.controls[steps.GRID].setValue($event)"
        (selectedGrid)="selectedGrid.set($event)"
      />
    </mat-step>

    <!-- REPORT STEP -->
    @if (showReportExport()) {
      <mat-step [stepControl]="$safeNavigationMigration(form?.get(steps.REPORT))" [completed]="$safeNavigationMigration(form?.get(steps.REPORT)?.valid)">
        <ng-template matStepLabel>{{ 'FAVORITE_VIEW.FORM.TABS_LABEL.REPORT' | translate }}</ng-template>
        <iot-platform-ui-favorite-view-report-form
          [favoriteView]="favoriteView()"
          [businessProfileId]="$safeNavigationMigration(information?.getRawValue()?.businessProfileId)"
          (formStateChanged)="formStateChanged()?.[steps.REPORT].set($event)"
          (formValue)="form.controls[steps.REPORT].setValue($event)"
        />
      </mat-step>

      <!-- SUBSCRIBERS STEP -->
      <mat-step
        [stepControl]="$safeNavigationMigration(form?.get(steps.SUBSCRIBERS))"
        [completed]="$safeNavigationMigration(form?.get(steps.SUBSCRIBERS)?.valid)"
      >
        <ng-template matStepLabel>{{ 'FAVORITE_VIEW.FORM.TABS_LABEL.SUBSCRIBERS' | translate }}</ng-template>
        <iot-platform-ui-favorite-view-subscribers-form
          [favoriteView]="favoriteView()"
          [isShared]="$safeNavigationMigration(information?.getRawValue()?.shared)"
          [isActive]="report?.getRawValue()?.status === FavoriteViewReportStatus.ACTIVE"
          [businessProfileId]="$safeNavigationMigration(information?.getRawValue()?.businessProfileId)"
          (formStateChanged)="formStateChanged()?.[steps.SUBSCRIBERS].set($event)"
          (formValue)="form.controls[steps.SUBSCRIBERS].setValue($event)"
        />
      </mat-step>
    }
  </mat-stepper>

  <div class="@container/actions bg-white px-6 pb-4">
    <div class="flex min-w-0 flex-wrap items-center justify-end gap-2 [&>button]:flex-1 @sm/actions:[&>button]:flex-initial">
      <button (click)="onCancel()" class="button-regular" color="accent" mat-raised-button>
        {{ 'IOT_DICTIONARY.CANCEL' | translate }}
      </button>

      <button (click)="stepper.previous()" [disabled]="stepper.selectedIndex === 0" class="button-regular" color="accent" mat-raised-button>
        {{ 'IOT_DICTIONARY.BACK' | translate }}
      </button>
      @if (stepper.selectedIndex !== stepper.steps.length - 1) {
        <button (click)="stepper.next()" [disabled]="!stepper.selected?.completed" class="button-regular" color="accent" mat-raised-button>
          {{ 'IOT_DICTIONARY.NEXT' | translate }}
        </button>
      } @else if (favoriteView()?.id) {
        <button (click)="onSave()" [disabled]="form.invalid || !formChanged()" class="button-regular" color="accent" mat-raised-button>
          {{ 'IOT_DICTIONARY.UPDATE' | translate }}
        </button>
      } @else {
        <button (click)="onSave()" [disabled]="form.invalid" class="button-regular" color="accent" mat-raised-button>
          {{ (favoriteView()?.name ? 'IOT_DICTIONARY.DUPLICATE' : 'IOT_DICTIONARY.CREATE') | translate }}
        </button>
      }
    </div>
  </div>
</div>
